import styled from 'styled-components';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// *************************************
// STYLED COMPONENTS                            
// *************************************

export const StyledRadioLabel = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    margin-left: -10px;
  }

  .MuiTypography-root {
    /* font-family: 'Bryant Pro Regular'; */
    font-size:  ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.0175em;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;

// Radio
export const StyledRadio = styled(Radio)`
  &.MuiRadio-root {
    color: ${(props) => props.theme.colors.greyDark};
    padding: 8px;
  }

  &.MuiIconButton-root:hover {
    background-color: ${(props) => props.theme.colors.greyHover};
  }

  &.MuiRadio-colorSecondary.Mui-checked {
    color: ${(props) => props.theme.colors.blueMedium};
  }

  &.MuiRadio-colorSecondary.Mui-checked:hover {
    background-color: ${(props) => props.theme.colors.blueMediumAlpha};
  }
`;

export const StyledRadioGroup = styled(RadioGroup)``;